import React, { Component } from 'react'
import {
  Admin,
  Resource
} from 'react-admin'

import restClient from './client/restClient'
import authClient from './client/authClient'

import messages from './utils/translations'
import PromoCode from './models/promocodes'
import User from './models/users'
import Apps from './models/apps'
import School from './models/schools'
import Class from './models/classes'
import { EmailList, EmailShow } from './models/emails'

import UserIcon from '@material-ui/icons/AccountCircle'
import GroupIcon from '@material-ui/icons/Group'
import CloudIcon from '@material-ui/icons/Cloud'
import SchoolIcon from '@material-ui/icons/School'
import EmailIcon from '@material-ui/icons/Email'
import LabelIcon from '@material-ui/icons/Label'
import ActivityIcon from '@material-ui/icons/AssignmentInd'
import PermIdentityIcon from '@material-ui/icons/PermIdentity'

import customSagas from './redux/saga/index'
import customReducers from './redux/reducers/index'
import { ActivityList, ActivityShow } from './models/activity'
import { SessionList, SessionShow } from './models/session'

const restClientOptions = {
  id: '_id',
  filterObjectIdFields: {
    promocode: {
      appId: true,
      activatedByUserId: true
    },
    user: {
      classId: true,
      schoolId: true
    },
    class: {
      schoolId: true
    },
    activity: {
      userId: true,
      appId: true
    },
    session: {
      userId: true
    }
  }
}

class App extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: true
    }
  }

  render () {
    return (
      <Admin
        authProvider={authClient}
        dataProvider={restClient(restClientOptions)}
        title='Daydream Education Admin'
        messages={messages}
        customSagas={customSagas}
        customReducers={customReducers}
      >
        <Resource
          name='user'
          icon={UserIcon}
          list={User.list}
          edit={User.edit}
        />
        <Resource
          name='app'
          icon={CloudIcon}
          list={Apps.list}
          edit={Apps.edit}
          create={Apps.create}
        />
        <Resource
          name='school'
          icon={SchoolIcon}
          list={School.list}
          edit={School.edit}
          create={School.create}
        />
        <Resource
          name='class'
          icon={GroupIcon}
          list={Class.list}
          edit={Class.edit}
          create={Class.create}
        />
        <Resource
          options={{ label: 'Promo Codes' }}
          name='promocode'
          icon={LabelIcon}
          list={PromoCode.list}
          edit={PromoCode.edit}
          create={PromoCode.create}
        />
        <Resource
          options={{ label: 'Email' }}
          name='email'
          icon={EmailIcon}
          list={EmailList}
          show={EmailShow}
        />
        <Resource
          options={{ label: 'Activity' }}
          name='activity'
          icon={ActivityIcon}
          list={ActivityList}
          show={ActivityShow}
        />
        <Resource
          options={{ label: 'Session' }}
          name='session'
          icon={PermIdentityIcon}
          list={SessionList}
          show={SessionShow}
        />
      </Admin>
    )
  }
}

export default App
